import Head from "next/head";

type TitleHeaderProps = {
    text: string;
    indexingOn?: boolean;
};

export const PageHead = ({ text, indexingOn = false }: TitleHeaderProps) => {
    return (
        <Head>
            <title>{text} - Accurx Patient Portal</title>
            <meta name="description" content={text} />
            {!indexingOn && <meta name="robots" content="noindex" />}
            <meta
                name="google-site-verification"
                content="tvNbP0rORU5drvw-BHt9_tDBvLPj9HR9HZfFmsgJEj4"
            />
            <meta
                name="msvalidate.01"
                content="ADEF11E91A825022FEBE6528E8BC5EE2"
            />
            <link rel="icon" href="/favicon.png" />
        </Head>
    );
};
